import React from 'react';
import {MODULE_LEVEL} from '../../data/modules';

const moduleStates = {
  [MODULE_LEVEL]: true,
};

class Module extends React.Component {
  render() {
    const {name, children} = this.props;
    return moduleStates[name] ? children : null;
  }
}

export default Module;



// WEBPACK FOOTER //
// ./src/components/common/module.jsx